module.exports = __webpack_public_path__ + "media/KikiN.eea3807b.mp3";